/**
 * INNFLOW DESIGN SYSTEM V2.0 - StatusDot Component
 * 
 * Indicador de status para usuários, agentes e sistemas
 * Conforme especificação INNFLOW System Architecture
 * 
 * @version 2.0.0
 * @author INNFLOW Design Team
 */

import React from 'react';
import { cn } from '@/lib/utils';
import './StatusDot.css';

export type StatusDotVariant = 'online' | 'offline' | 'away' | 'busy' | 'error';
export type StatusDotSize = 'xs' | 'sm' | 'md' | 'lg';

export interface StatusDotProps {
  variant: StatusDotVariant;
  size?: StatusDotSize;
  className?: string;
  'aria-label'?: string;
}

/**
 * StatusDot - Indicador de status com animação pulse
 * 
 * Estados:
 * - online: Verde com animação pulse (usuários ativos)
 * - offline: Cinza (usuários offline)
 * - away: Amarelo (usuários ausentes)
 * - busy: Amarelo (ocupado)
 * - error: Vermelho com animação pulse (erro)
 */
export const StatusDot: React.FC<StatusDotProps> = ({
  variant,
  size = 'sm',
  className,
  'aria-label': ariaLabel,
}) => {
  return (
    <span
      className={cn(
        'innflow-status-dot',
        `innflow-status-dot--${variant}`,
        `innflow-status-dot--${size}`,
        className
      )}
      aria-label={ariaLabel || `Status: ${variant}`}
      role="status"
      aria-live="polite"
    />
  );
};

export default StatusDot;
